import { render, staticRenderFns } from "./CustomDxFileUploader.vue?vue&type=template&id=6e6237cf&scoped=true&"
import script from "./CustomDxFileUploader.vue?vue&type=script&lang=js&"
export * from "./CustomDxFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./CustomDxFileUploader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomDxFileUploader.vue?vue&type=style&index=1&id=6e6237cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6237cf",
  null
  
)

export default component.exports